/**
 * Minimum width of the encounter's procedure-code billing table: EncounterBillingTable and the
 * BillerSectionTable that replaces it behind the billing pipeline flag show the same six columns.
 * Below this the columns scroll sideways instead of squeezing the action icons.
 */
export const BILLING_TABLE_MIN_WIDTH = 720;
